//#region src/components/pd-spa-helper/spa-events.ts
/**
* SPA event name constants.
* All events use the `pd-spa:` prefix for namespacing.
*/
var SPA_EVENTS = {
	/** Fired when the SPA has been initialized */
	INIT: "pd-spa:init",
	/** Fired to show a toast notification */
	TOAST: "pd-spa:toast",
	/** Fired for navigation events */
	ROUTE: "pd-spa:route",
	/** Fired when login was successful */
	LOGIN_SUCCESS: "pd-spa:login-success",
	/** Fired when locale changes */
	LOCALE_CHANGE: "pd-spa:locale-change",
	/** Fired by pages to register their sections with the framework. */
	REGISTER_SECTIONS: "pd-spa:register-sections",
	/** Fired to request app configuration */
	APP_CONFIG: "pd-spa:app-config"
};
/**
* Create a typed CustomEvent with proper options
*/
function createSpaEvent(type, detail, options) {
	return new CustomEvent(type, {
		detail,
		bubbles: options?.bubbles ?? true,
		composed: options?.composed ?? true
	});
}
/**
* Dispatch an init event
*/
function dispatchInit(target = document) {
	target.dispatchEvent(createSpaEvent(SPA_EVENTS.INIT, void 0));
}
//#endregion
export { SPA_EVENTS, dispatchInit };
